// @ts-nocheck

export const localeCodes =  []
export const localeLoaders = {}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/2999756a" /* webpackChunkName: "config_i18n_46config_46js_2999756a" */)
]
export const normalizedLocales = []

